<template>

  <b-sidebar
    id="sidebar-update-check-monitoring"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="checkMonitoringCreate">

          <!-- Uz Name -->
          <b-form-group
            :label="$t('Status')"
            label-for="status"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Status')"
              rules="required"
            >
              <v-select
                id="period"
                v-model="status"
                :reduce="(option) => option.id"
                :options="statuses"
                :label="$i18n.locale"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            :label="$t('Reason')"
            label-for="reason_status"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Reason')"
              rules=""
            >
              <v-select
                id="period"
                v-model="reason_status"
                :reduce="(option) => option.id"
                :options="reason_statuses"
                :label="$i18n.locale"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        <!-- Form Actions -->
        </validation-observer>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Create') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>
<script>
import {
  BButton, BForm, BFormInput, BFormGroup, BSidebar,
} from 'bootstrap-vue'
import { localize, ValidationObserver, ValidationProvider } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@/libs/validations/validations'

export default {
  name: 'CheckMonitoringCreate',
  directives: {
    Ripple,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    vSelect,
  },
  data() {
    return {
      required,
      status: null,
      reason_status: null,
    }
  },
  computed: {
    statuses() {
      return this.$store.state.staticModule.checkMonitoringStatus
    },
    reason_statuses() {
      return this.$store.state.staticModule.checkMonitoringReasonStatus
    },
    monitoringReport() {
      return this.$store.state.monitoringReport.monitoringReport
    },
  },
  mounted() {
    this.loadData()
  },
  created() {
    localize(this.$i18n.locale)
  },
  methods: {
    loadData() {
      this.$store.dispatch('staticModule/periodList')
    },
    clear(hide) {
      this.$store.commit('monitoringReport/GET', {})
      this.$refs.checkMonitoringCreate.reset()
      hide()
    },
    submit(hide) {
      this.$refs.checkMonitoringCreate.validate().then(success => {
        if (success) {
          const data = {
            status: this.status,
            reason_status: this.reason_status,
            org_monitoring: this.$route.params.id,
            monitoring_report: this.monitoringReport.id,
          }
          this.$createSwal(this, data, 'checkMonitoring/create', () => {
            this.$emit('refetchData')
            this.freshData()
          })
          hide()
        }
      })
    },
    freshData() {
      this.status = null
      this.reason_statuses = null
    },
  },
  setup() {
  },
}
</script>

  <style scoped />
